class Details {
  constructor(data) {
    this.email = data.email;
    this.message = data.message;
    this.remainingLockTimeInMilliseconds = data.remainingLockTimeInMilliseconds;
  }
}

export default Details;
